let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hXbUA")).then(() => parcelRequire('1XtOv'));